import React, { useState } from "react";    
import { Background } from "@/components";
import { useNavigate } from "react-router-dom";
import PhoneAuthLogin from "./PhoneAuth";
import '@/css/auth.css';

const Login = ({ onComplete }: { onComplete: () => void }) => {
  const completeLogin = () => {
    onComplete();
  };

  return (
      <div className="content-wrapper">
        {<PhoneAuthLogin nextStep={completeLogin}/>}
      </div>
  );
};

export default Login;
